import { BaseModel } from '@app/shared/models/base';
import * as _ from 'lodash-es';

export class VehicleDamageMetaContainer extends BaseModel {
    public type: string;
    public type_translated: string;
    public meta: VehicleDamageMeta[];

    get translationCode(): string {
        return `damage-area-selector.vehicle.type.${this.type}`;
    }

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            meta: json && json.meta ? json.meta.map(vehicleDamageMeta => new VehicleDamageMeta(vehicleDamageMeta)) : []
        });
    }
}

export class VehicleDamageMetaResponse extends BaseModel {

    public bicycle: VehicleDamageMetaContainer[];
    public bus: VehicleDamageMetaContainer[];
    public caravan: VehicleDamageMetaContainer[];
    public motorcaravan: VehicleDamageMetaContainer[];
    public motorcycle: VehicleDamageMetaContainer[];
    public passengercar: VehicleDamageMetaContainer[];
    public tipper: VehicleDamageMetaContainer[];
    public tractor: VehicleDamageMetaContainer[];
    public truck: VehicleDamageMetaContainer[];
    public van: VehicleDamageMetaContainer[];
    public forklift: VehicleDamageMetaContainer[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            bicycle     : json && json.bicycle ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.BICYCLE, meta: json.bicycle }) : null,
            bus         : json && json.bus ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.BUS, meta: json.bus }) : null,
            boat        : json && json.boat ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.BOAT, meta: json.boat }) : null,
            caravan     : json && json.caravan ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.CARAVAN, meta: json.caravan }) : null,
            motorcaravan: json && json.motorcaravan ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.MOTORCARAVAN, meta: json.motorcaravan }) : null,
            motorcycle  : json && json.motorcycle ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.MOTORCYCLE, meta: json.motorcycle }) : null,
            passengercar: json && json.passengercar ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.PASSENGERCAR, meta: json.passengercar }) : null,
            tipper      : json && json.tipper ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.TIPPER, meta: json.tipper }) : null,
            tractor     : json && json.tractor ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.TRACTOR, meta: json.tractor }) : null,
            truck       : json && json.truck ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.TRUCK, meta: json.truck }) : null,
            van         : json && json.van ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.VAN, meta: json.van }) : null,
            forklift    : json && json.forklift ? new VehicleDamageMetaContainer({ type: VehicleDamageMeta.TYPES.FORKLIFT, meta: json.forklift }) : null
        });
    }

    public getAsArray(): VehicleDamageMetaContainer[] {
        const arr = [];

        _.forEach(VehicleDamageMeta.TYPES, (type) => {
            arr.push(this[type.toLowerCase()]);
        });

        return arr;
    }
}

export class VehicleDamageMeta extends BaseModel {
    public static TYPES = { // The order of the below TYPES is important
        PASSENGERCAR: 'PASSENGERCAR',
        VAN         : 'VAN',
        MOTORCYCLE  : 'MOTORCYCLE',
        TRUCK       : 'TRUCK',
        BUS         : 'BUS',
        CARAVAN     : 'CARAVAN',
        MOTORCARAVAN: 'MOTORCARAVAN',
        TRACTOR     : 'TRACTOR',
        TIPPER      : 'TIPPER',
        FORKLIFT    : 'FORKLIFT',
        BOAT        : 'BOAT',
        BICYCLE     : 'BICYCLE'
    };

    public graphic_key: string;
    public graphic_key_translated: string;

    get translationCode(): string {
        return `damage-area-selector.vehicle.${this.graphic_key}`;
    }

    get imageLink(): string {
        return `./assets/images/damage-area-selector/${this.graphic_key}.png`;
    }

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json));
    }
}
